<template>
  <footer class="footer bg-gray-900 border-t border-gray-700 mt-auto">
    <div class="container mx-auto px-4 py-8">
      <div class="grid grid-cols-1 md:grid-cols-4 gap-8">
        <!-- Brand -->
        <div class="space-y-4">
          <div class="flex items-center space-x-2">
            <div class="w-8 h-8 bg-purple-600 rounded-full flex items-center justify-center">
              <span class="text-white font-bold">C</span>
            </div>
            <span class="text-xl font-bold text-white">CuttleFusion</span>
          </div>
          <p class="text-gray-400 text-sm">
            The ultimate blockchain NFT trading card game. Collect, customize, and battle!
          </p>
        </div>
        
        <!-- Game -->
        <div class="space-y-4">
          <h3 class="text-white font-semibold">Game</h3>
          <ul class="space-y-2 text-sm">
            <li><router-link to="/game" class="text-gray-400 hover:text-white transition-colors">Play Now</router-link></li>
            <li><router-link to="/collection" class="text-gray-400 hover:text-white transition-colors">My Collection</router-link></li>
            <li><router-link to="/mint" class="text-gray-400 hover:text-white transition-colors">Mint NFTs</router-link></li>
            <li><router-link to="/leaderboard" class="text-gray-400 hover:text-white transition-colors">Leaderboard</router-link></li>
          </ul>
        </div>
        
        <!-- Marketplace -->
        <div class="space-y-4">
          <h3 class="text-white font-semibold">Marketplace</h3>
          <ul class="space-y-2 text-sm">
            <li><router-link to="/marketplace" class="text-gray-400 hover:text-white transition-colors">Browse</router-link></li>
            <li><a href="#" class="text-gray-400 hover:text-white transition-colors">Sell</a></li>
            <li><a href="#" class="text-gray-400 hover:text-white transition-colors">Auctions</a></li>
            <li><a href="#" class="text-gray-400 hover:text-white transition-colors">Trading</a></li>
          </ul>
        </div>
        
        <!-- Community -->
        <div class="space-y-4">
          <h3 class="text-white font-semibold">Community</h3>
          <ul class="space-y-2 text-sm">
            <li><router-link to="/about" class="text-gray-400 hover:text-white transition-colors">About</router-link></li>
            <li><a href="#" class="text-gray-400 hover:text-white transition-colors">Discord</a></li>
            <li><a href="#" class="text-gray-400 hover:text-white transition-colors">Twitter</a></li>
            <li><a href="#" class="text-gray-400 hover:text-white transition-colors">Documentation</a></li>
          </ul>
        </div>
      </div>
      
      <div class="border-t border-gray-700 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
        <p class="text-gray-400 text-sm">
          © 2025 CuttleFusion. All rights reserved.
        </p>
        <p class="text-gray-400 text-sm mt-2 md:mt-0">
          Built on Ethereum blockchain
        </p>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
// Footer component
</script>

<style scoped>
.footer {
  background: linear-gradient(135deg, #111827 0%, #1f2937 100%);
}
</style>